import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-photo-box',
  standalone: true,
  templateUrl: './photo-box.component.html',
  styleUrls: ['./photo-box.component.scss'],
})
export class PhotoBoxComponent {
  @Input() profileImage: string | null = null;
  @Input() contentType: string | null = null;
}


